var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.customClass ? _vm.customClass : ''},[(_vm.type === 'global' && _vm.isLoading)?_c('div',{staticClass:"loading-overlay"}):_vm._e(),_vm._v(" "),_c('div',{class:( _obj = {}, _obj[_vm.loaderType] = _vm.isLoading, _obj )},[_c('div',{staticClass:"loader"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc2871e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = null
// module chunks = 